import hampiImg from '../assets/home/Trvto-Hampi.JPG';
import himalayaImg from '../assets/home/Trvto_Himalaya.jpg';
import trek from '../assets/home/Trvto-trek.jpg';
import camping from '../assets/home/Trvto-camping.jpg';

export const BannerImageData = {
    data: [
        {
            url: trek,
            alt: 'img1 for trvto banner'
        },
        {
            url: camping,
            alt: 'img2 for trvto banner'
        },
        {
            url: hampiImg,
            alt: 'img3 for trvto banner'
        },
        {
            url: himalayaImg,
            alt: 'img4 for trvto banner'
        }
    ]
};
